// search contexts
export const SEARCH_CONTEXTS = Object.freeze({
  COMPONENT: 'component',
  CONTAINER: 'container',
  PAGE_COMPONENT: 'pageComponent',
  PAGE_OR_FOLDER: 'pageOrFolder'
});

// map filter keys to display text
export const SEARCH_KEY_TEXT_MAP = {
  ComponentName: 'Name',
  Name: 'Name',
  PageName: 'Name',
  Route: 'Route',
  SchemaName: 'Component',
  'Tags.NameTags': 'Tags',
  'Tags.UserTags': 'Tags'
};

export const SEARCH_RESULTS = {
  resultsPerPage: 12,
  pageNumsPerPage: 7,
  unnamedComponent: '*unnamed component*',
  unnamedPage: '*unnamed page*'
};

// redux
export const FILTER_ADDED = 'search/FILTER_ADDED';
export const FILTER_DELETED = 'search/FILTER_DELETED';
export const FILTERS_SET = 'search/FILTERS_SET';
export const SEARCH_CONTEXT_CLEARED = 'search/SEARCH_CONTEXT_CLEARED';
export const SEARCH_RESULTS_CLEARED = 'search/SEARCH_RESULTS_CLEARED';
export const SEARCH_RESULTS_FULFILLED = 'search/SEARCH_RESULTS_FULFILLED';
export const SEARCH_RESULTS_REJECTED = 'search/SEARCH_RESULTS_REJECTED';
export const SEARCH_RESULTS_REQUESTED = 'search/SEARCH_RESULTS_REQUESTED';
export const SEARCH_SUGGESTIONS_FULFILLED = 'search/SEARCH_SUGGESTIONS_FULFILLED';
export const SEARCH_SUGGESTIONS_REJECTED = 'search/SEARCH_SUGGESTIONS_REJECTED';
export const SEARCH_SUGGESTIONS_REQUESTED = 'search/SEARCH_SUGGESTIONS_REQUESTED';
export const SEARCH_STORE_PAGE_NUM = 'search/SEARCH_STORE_PAGE_NUM';
export const SEARCH_STORE_CONTEXT = 'search/SEARCH_STORE_CONTEXT';
